module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/plus-icon-4956695a3218fe2dae41f167f875424d.svg";